// Thin wrapper around the GA4 gtag global loaded in index.html. Safe to call
// from anywhere, if gtag isn't available (dev, ad blockers, server render)
// the call no-ops silently.

type GtagFn = (
  command: "event",
  eventName: string,
  params?: Record<string, unknown>,
) => void;

export function track(eventName: string, params?: Record<string, unknown>): void {
  if (typeof window === "undefined") return;
  const w = window as unknown as { gtag?: GtagFn };
  try {
    w.gtag?.("event", eventName, params);
  } catch {
    // Swallow, never crash the app for analytics.
  }
}
